import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Tabs, TabPanel } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import {
  Tab,
  TabList,
  TabPanels,
  HorizontalSeparator,
} from './styles';
import messages from './messages';
import HelpView from './HelpView';
import EtextHelpView from './EtextHelpView';
/**
 * TabsNavigation
 *
 * @param {object} intl  react-intl for translation
 *
 */
function TabsNavigation({ helpContext }) {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <Tabs
      index={tabIndex}
      onChange={setTabIndex}
    >
      <TabList>
        <Tab>{intl.formatMessage(messages.eTextHelp)}</Tab>
        <Tab>{intl.formatMessage(messages.iLabsHelp)}</Tab>
      </TabList>
      <HorizontalSeparator />
      <TabPanels>
        {tabIndex === 0 && <TabPanel><EtextHelpView /></TabPanel>}
        {tabIndex === 1 && <TabPanel><HelpView helpContext={helpContext} /></TabPanel>}
      </TabPanels>
    </Tabs>
  );
}

TabsNavigation.propTypes = {
  helpContext: PropTypes.string,
};

export default TabsNavigation;
